var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatacollectorMobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.93 20.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "data collector mobil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.58,26.76a4.49,4.49,0,0,0-6.68-5.35,7.48,7.48,0,0,0-14,3.73c0,.13,0,.26,0,.38a6.74,6.74,0,0,0,2.23,13.09H34.38a6,6,0,0,0,1.2-11.85Z",
    transform: "translate(-10.44 -17.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.39,
    y: 7.78,
    width: 3.29,
    height: 9.35,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.62,
    y: 12.46,
    width: 3.29,
    height: 4.68,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.84 10.21 18.84 11.94 18.84 15.5 18.84 17.14 22.14 17.14 22.14 12.82 22.14 11.94 22.14 10.21 18.84 10.21",
    fill: "#05548e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacollectorMobil);
export default __webpack_public_path__ + "static/media/datacollector-mobil.625714201f11f36461f8b6e66c22a59e.svg";
export { ForwardRef as ReactComponent };